import { Component } from 'react'
import PropTypes from 'prop-types'
import  TextArea  from 'components/textarea'
import { Row, Col } from 'react-flexbox-grid'
import intl from 'react-intl-universal'

import './alterar-pedido-fornecedor.css'
import Button from 'components/button'

class AlterarPedidoFornecedor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      observacao: ''
    };
  }

  onChangeValue = (prop, value) => {
    this.setState({
      [prop]: value      
    });
  };

  render() {
    const { observacao } = this.state
    const {
      idMaterialAnterior,
      descricaoMaterialAnterior,
      idMaterialNovo,
      descricaoMaterialNovo,
      idPedido,
      handleAccept,
      handleRefuse
    } = this.props
    return (
      <div className="alterar-pedido-fornecedor">
        <div className="alterar-pedido-fornecedor-line">
            <Row>
              <Col>
                <div className="alterar-pedido-fornecedor-read-column">
                  <span>{intl.get('stocks.timeline.previous')}</span>
                  <span>{descricaoMaterialAnterior}</span>
                </div>
              </Col>
            </Row>
        </div>
        <div className="alterar-pedido-fornecedor-line">
          <Row>
            <Col>
              <div className="alterar-pedido-fornecedor-read-column">
                <span>{intl.get('stocks.timeline.new')}</span>
                <span>{descricaoMaterialNovo}</span>
              </div>
            </Col>
          </Row>
        </div>
        <div className="alterar-pedido-fornecedor-line">
          <Row>
            <Col>
              <TextArea
                name="txbObservacao"
                label={intl.get('commons.observation')}
                value={observacao || ''}
                onChange={(event) => this.onChangeValue('observacao', event.currentTarget.value)}                
              />
            </Col>
          </Row>
        </div>
        <div className="alterar-pedido-fornecedor-line">
          <Row>
              <Col xl={6}>
                <Button
                    value={intl.get('stocks.timeline.refuse')}
                    onClick={() => handleRefuse(idPedido, observacao)}
                    buttonType="danger"
                    className="button"
                  />
              </Col>
              <Col xl={6}>
                <Button
                  value={intl.get('stocks.timeline.accept')}
                  onClick={() => handleAccept(idPedido, idMaterialAnterior, idMaterialNovo, observacao)}
                  buttonType="primary"
                  className="button"
                />
              </Col>
            </Row>
        </div>
      </div>
    )
  }
}

AlterarPedidoFornecedor.propTypes = {
  descricaoMaterialAnterior: PropTypes.any.isRequired,
  descricaoMaterialNovo: PropTypes.any.isRequired,
  handleAccept: PropTypes.func.isRequired,
  handleRefuse: PropTypes.func.isRequired,
  idMaterialAnterior: PropTypes.any.isRequired,
  idMaterialNovo: PropTypes.any.isRequired,
  idPedido: PropTypes.number.isRequired,
}

export default AlterarPedidoFornecedor